var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"dense":"","headers":_vm.headers,"items":this.$store.getters['filteredRecommendationsWithExtras'],"single-select":false,"show-select":"","item-key":"name","footer-props":{ itemsPerPageOptions: [10, 100, -1] }},scopedSlots:_vm._u([{key:"body.prepend",fn:function(ref){
var isMobile = ref.isMobile;
return [_c('FiltersRow',{attrs:{"isMobile":isMobile}})]}},{key:"item.resourceCol",fn:function(ref){
var item = ref.item;
return [_c('ResourceCell',{attrs:{"rowRecommendation":item}})]}},{key:"item.projectCol",fn:function(ref){
var item = ref.item;
return [_c('ProjectCell',{attrs:{"rowRecommendation":item}})]}},{key:"item.typeCol",fn:function(ref){
var item = ref.item;
return [_c('TypeCell',{attrs:{"rowRecommendation":item}})]}},{key:"item.description",fn:function(ref){
var item = ref.item;
return [_c('DescriptionCell',{attrs:{"rowRecommendation":item}})]}},{key:"item.costCol",fn:function(ref){
var item = ref.item;
return [_c('SavingsCostCell',{attrs:{"rowRecommendation":item}})]}},{key:"item.statusCol",fn:function(ref){
var item = ref.item;
return [_c('ApplyAndStatusCell',{attrs:{"rowRecommendation":item}})]}}]),model:{value:(_vm.selectedRows),callback:function ($$v) {_vm.selectedRows=$$v},expression:"selectedRows"}})}
var staticRenderFns = []

export { render, staticRenderFns }